import * as ActionTypes from "./../ActionTypes";

export const USER = (state = { user: null, error: null, loading: false }, action) => {
    switch (action.type) {
        case ActionTypes.REQ_AUTH:
            return { ...state, user: null, error: null, loading: true };

        case ActionTypes.AUTH:
            localStorage.setItem("profile", JSON.stringify({ ...action?.payload }));
            return { ...state, user: action?.payload?.user, error: null, loading: false };

        case ActionTypes.AUTH_ERROR:
            return { ...state, user: null, error: action?.payload, loading: false };

        default:
            return { user: null, error: null, loading: false };
    }
}